import { z } from 'zod'

import { realtimeHttp } from '@/shared/api'

const credentialsSchema = z.object({
  token: z.string(),
  /** The one channel this user may subscribe to, e.g. `personal:<sub>`. */
  channel: z.string(),
})

export type RealtimeCredentials = z.infer<typeof credentialsSchema>

/**
 * Stream tokens are short-lived — 60 seconds here — so this is called on every
 * connect and every reconnect. Never call it once and keep the result.
 */
export const fetchRealtimeCredentials = (): Promise<RealtimeCredentials> =>
  realtimeHttp.get('realtime/token', { schema: credentialsSchema })
